import { useRealtime, useTranslation } from '@/contexts';
import { formatLastUpdated } from '../utils';
import styles from './LiveStatus.module.css';

/**
 * Связь с сервером. Состояние передаёт цвет точки:
 * зелёная — соединение с Centrifugo установлено, оранжевая — идёт подключение,
 * серая — связи нет. Подробности и время последнего сообщения — в подсказке.
 */
export function LiveStatus() {
  const { t } = useTranslation();
  const { status, lastActivityAt } = useRealtime();

  const dotClass =
    status === 'connected'
      ? styles.dotLive
      : status === 'connecting'
        ? styles.dotConnecting
        : styles.dotOffline;

  const stateLabel = t(`connection.${status}`);
  const hint = lastActivityAt
    ? `${stateLabel} · ${t('connection.updated', {
        time: formatLastUpdated(lastActivityAt.toISOString()),
      })}`
    : stateLabel;

  return (
    <div className={styles.wrapper} title={hint}>
      <span className={`${styles.dot} ${dotClass}`} aria-hidden />
      <span className={styles.label}>{t('connection.title')}</span>
    </div>
  );
}
